const ASSIGNEE_TYPE_TAB_KEYS = {
    me: 'mineCount',
    unassigned: 'unAssignedCount',
    all: 'allCount',
  };
  
  const ASSIGNEE_TYPE_TAB_KEYS_MINE = {
    me: 'mineCount',
  };

  const isPrivateConversationEnable = account =>
    account.private_conversations === true;

  const isPrivateContactsEnable = account =>
    account.private_contacts === true;

  const isAdminUser = user => user.role === 'administrator';
  
  const allConversations = (account, user) =>
    isAdminUser(user) || !isPrivateConversationEnable(account);
  export const getAssigneeTypeTabsByPrivateType = (user, account) => {
    if (allConversations(account, user)) return ASSIGNEE_TYPE_TAB_KEYS;
  
    return ASSIGNEE_TYPE_TAB_KEYS_MINE;
  };
  
  export const shouldSetContact = (user, account) => {
    return (
      isAdminUser(user) ||
      (!isAdminUser(user) && !isPrivateContactsEnable(account))
    );
  };

  export const contactHasAppliedFilters = ({ contacts }) => {
    console.log("Enter contactHasAppliedFilters")
    if (!contacts) return false;

    const { appliedFilters } = contacts;
    return Array.isArray(appliedFilters) && appliedFilters.length > 0;
  };

 export const contactHasSearchbarActive = ({ route }) =>
  route.name === 'contacts_dashboard_index' &&
  !!route.query?.search;

